module.exports = __webpack_public_path__ + "img/icommunity_sys-08_en.d10ec49f.jpg";